import { twMerge } from 'tailwind-merge'
import { AudioPreviewLoader } from 'shared/components/audio-loader'
import {
  AttachmentUploadStatusEnum,
  AudioUploadAttachment,
} from 'modules/community/types/post-attachment'

interface AudioAttachmentPreviewProps {
  className?: string
  attachment: AudioUploadAttachment
  size?: 'small' | 'original'
}

export default function AudioAttachmentPreview({
  attachment,
  className,
  size = 'small',
}: AudioAttachmentPreviewProps) {
  return (
    <div
      className={twMerge(
        'flex size-full overflow-hidden rounded-lg',
        attachment.status === AttachmentUploadStatusEnum.Uploading && 'bg-background-primary',
        className,
      )}
    >
      {attachment.status !== AttachmentUploadStatusEnum.Uploading && (
        <div className="w-full">
          <AudioPreviewLoader className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 md:size-8 lg:size-16" />
          <span className="flex h-[90%] flex-col items-center justify-end text-xs text-text-tertiary">
            {attachment.name}
          </span>
        </div>
      )}
    </div>
  )
}
